import { contrastRatio } from '../utils/contrastRatio';

/** The Build fallback for the active rail icon: the least darkening of the
 * brand orange that clears 3:1 on white (3.58:1) and holds on every dark
 * surface (4.86:1 on #1A1A1A). */
export const ACTIVE_ACCENT_FALLBACK = '#E55C00';

/** WCAG 1.4.11: non-text UI components need 3:1 against adjacent colour. */
export const ACTIVE_ACCENT_MIN_CONTRAST = 3;

/** The surface the active icon actually sits on in each mode -- the light
 * `surface` token is the keyword `white`, so the hex is spelled out here. */
const SURFACE_BY_MODE = { light: '#FFFFFF', dark: '#1A1A1A' };

/**
 * Choose the active-icon accent for the current mode.
 *
 * The organisation's skin accent is used when it reads clearly against the
 * surface it sits on; otherwise the Build orange. Evaluated per mode, so an
 * accent that works on white but vanishes on #1A1A1A gets the fallback in dark
 * only. Unparseable or missing accents (skins from the API can be empty) fall
 * back too.
 */
const pickActiveAccent = (skinAccent, isDark) => {
  const surface = isDark ? SURFACE_BY_MODE.dark : SURFACE_BY_MODE.light;
  const ratio = contrastRatio(skinAccent, surface);
  if (ratio !== null && ratio >= ACTIVE_ACCENT_MIN_CONTRAST) {
    return skinAccent;
  }
  return ACTIVE_ACCENT_FALLBACK;
};

export default pickActiveAccent;
